/**
 * زر «اسأل المساعد» — برتقالي ثابت في الركن، في كل الشاشات عدا الدخول.
 * ⛔ الاسم «المساعد» — ممنوع أي إشارة لذكاء اصطناعي في نص الواجهة.
 */
import { Icon } from "./Icon";

export function AssistantFab({ onClick }: { onClick?: () => void }) {
  return (
    <button type="button" className="fab" onClick={onClick}>
      <Icon name="chat" size={17} stroke="#0F1D33" />
      {/* النص بيختفي على الموبايل — الزرار كان بيغطّي أزرار المهمة في الكارت */}
      <span className="fab-label">اسأل المساعد</span>
    </button>
  );
}
